<template>
  <router-view></router-view>
</template>

<script>
export default {
  page: {
    title: 'Expense Manager',
    meta: [
      {
        name: 'description',
        content: 'Manage  Expense ',
      },
    ],
  },
}
</script>
